import { Badge } from "@/components/ui/badge";

export type BillingSourceType =
  | "pay_per_use" | "overage" | "addon" | "other" | "Plan_Rental" | "Late_Fee";

const SOURCE_CLASS: Record<BillingSourceType, string> = {
  pay_per_use: "bg-primary/10 text-primary border-primary/20",
  overage:     "bg-amber-100 text-amber-700 border-amber-200",
  addon:       "bg-purple-100 text-purple-700 border-purple-200",
  other:       "bg-zinc-100 text-zinc-600 border-zinc-200",
  Plan_Rental: "bg-blue-100 text-blue-700 border-blue-200",
  Late_Fee:    "bg-red-100 text-red-700 border-red-200",
};

const LABELS: Record<BillingSourceType, string> = {
  pay_per_use: "Pay-per-use",
  overage:     "Overage",
  addon:       "Add-on",
  other:       "Other",
  Plan_Rental: "Plan Rental",
  Late_Fee:    "Late Fee",
};

export function BillingSourceBadge({ sourceType }: { sourceType: BillingSourceType | string }) {
  const key = (sourceType as BillingSourceType) in SOURCE_CLASS ? (sourceType as BillingSourceType) : "other";
  return (
    <Badge variant="outline" className={`${SOURCE_CLASS[key]} text-xs`}>{LABELS[key]}</Badge>
  );
}
